import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const StepVersionOk = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <circle cx={8} cy={8} fill="#4EB76C" r={5.333} />
    <path d="m5.051 8.138.991-.943L7.3 8.391 9.813 6l.991.943L7.3 10.276 5.051 8.138Z" fill="#fff" />
  </Icon>
));

export default StepVersionOk;
